import { render, staticRenderFns } from "./TotalTemplate.vue?vue&type=template&id=6f5f360e&"
import script from "./TotalTemplate.vue?vue&type=script&lang=js&"
export * from "./TotalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TotalTemplate.vue?vue&type=style&index=0&id=6f5f360e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports